import { memo } from 'react'

interface KakaoLoginButtonProps {
  handleKakaoLogin: () => void
}

const KakaoLoginButton = memo(({ handleKakaoLogin }: KakaoLoginButtonProps) => {
  return (
    <button
      onClick={handleKakaoLogin}
      className='w-full flex items-center justify-center px-4 py-3 rounded-lg bg-yellow-400 hover:bg-yellow-500 transition-colors duration-200 noto-sans-kr'
    >
      <svg className='w-5 h-5 mr-3' viewBox='0 0 24 24'>
        <path
          fill='#000000'
          d='M12 3C7.03 3 3 6.24 3 10.25c0 2.58 1.67 4.86 4.19 6.24l-.98 3.6c-.11.4.32.74.69.54l4.65-3.07c.48.06.98.09 1.45.09 4.97 0 9-3.24 9-7.25S16.97 3 12 3z'
        />
      </svg>
      <span className='text-black text-sm font-medium'>카카오로 로그인</span>
    </button>
  )
})

KakaoLoginButton.displayName = 'KakaoLoginButton'

export default KakaoLoginButton
